import { useMemo } from "react";

import { type Distribution, type LensDestination } from "../../gql-generated/types";
import { addAdAccountsFromLensCentralDistributions } from "../state";

interface LensWithDestinationTypes {
    id: string;
    destinations: readonly LensDestination[];
    distributionsList: readonly Distribution[];
}

export const useLensDestinationTypesFromLens = ({
    id,
    destinations,
    distributionsList,
}: LensWithDestinationTypes): readonly LensDestination[] =>
    useMemo(
        () => addAdAccountsFromLensCentralDistributions(destinations, distributionsList, id),
        [destinations, distributionsList, id],
    );
